import { AnnotationCanvasStylePartialType } from '../imports/annotation-canvas';
import { Alpha, Percent } from '../imports/utils';

export const [
  // dummy comment to control prettier
  saturationDarker,
  saturationLighter
]: [Percent, Percent] = [80, 100];

export const [
  // dummy comment to control prettier
  lightnessDarker,
  lightnessLighter
]: [Percent, Percent] = [50, 90];

const highlightAlpha: Alpha = 0.4;

export const annotationCanvasStyle: AnnotationCanvasStylePartialType = {
  root: {
    width: '100%',
    height: '100%'
  },
  background: 'checkerboard',
  bgMinPaddingPx: 30,
  bbox: {
    boxShadowWidthPx: 0,
    borderWidthPx: {
      notSelected: 2,
      selected: 3
    },
    pointOpacity: 1,
    pointWidthPx: 8,
    borderColorSLA: {
      notSelected: [saturationDarker, lightnessDarker, 1],
      selected: [saturationLighter, lightnessLighter, 1]
    },
    highlightedFaceColorSLA: [saturationDarker, lightnessDarker, highlightAlpha]
  },
  labelSaturation: saturationDarker,
  labelLightness: lightnessDarker
};
